/**
 * Created by Carsten Bühler
 * User: CBuehler on 27.01.2016
 * Copyright: xdot GmbH 2015
 */
'use strict';

//Includes
import React from 'external/react';
import PropTypes from 'external/prop-types';
import { AppContext } from '../app-context';
import translation from '../utils/translation';
import { FlagComponent } from '../components/FlagHOC';
import DataListHoc from './DataListHoc';
import { AutoSizer, CellMeasurer, CellMeasurerCache, InfiniteLoader, List } from 'external/react-virtualized';
import * as DataUtil from '../utils/data-util';
import debounce from '../utils/debounce';
import shallowEqual from '../utils/shallowEqual';

class ScrollableDataListRV extends React.Component {

  constructor(props) {
    super(props);
    this.rowRenderer = this.rowRenderer.bind(this);
    this.isRowLoaded = this.isRowLoaded.bind(this);
    this.onResize = this.onResize.bind(this);

    this._cache = new CellMeasurerCache({
      fixedWidth: true,
      minHeight: 50,
      rowHeight: this.props.rowHeight,
    });
  }

  componentDidMount() {
    window.onresize = debounce(this.onResize, 50);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      (!shallowEqual(this.props.activeIds, nextProps.activeIds)) ||
      (!shallowEqual(this.props.disabledIds !== nextProps.disabledIds)) ||
      (this.props.list._end !== nextProps.list._end)
    ) {
      this.loader && this.loader._registeredChild.forceUpdateGrid();
    }
  }

  componentWillUnmount() {
    window.onresize = undefined;
  }

  onResize() {
    this.forceUpdate();
  }

  scrollToIndex(idx) {
    this.loader && this.loader._registeredChild.scrollToRow(idx);
  }

  checkInIdList(item, idItem, propName) {
    const id = propName ? item[propName] : item.id;
    let active = false;
    if (idItem) {
      if (idItem.item) {
        if (Array.isArray(idItem.item)) {
          let items = DataUtil.asArray(idItem);
          items.forEach(i => {
            const itemId = i && propName ? i[propName] : i.id;
            if (id === itemId) {
              active = true;
            }
          });
        } else {
          let item2 = DataUtil.asItem(idItem);
          if (item2) {
            const itemId = propName ? item2[propName] : item2.id;
            if (id === itemId) {
              return true;
            }
          }
        }
      } else {
        const itemId = propName ? idItem[propName] : idItem.id;
        if (id === itemId) {
          return true;
        }
      }
    }
    return active;
  }

  rowRenderer({ index, key, parent, style }) {
    //TODO We should only propagate known props
    const {
      list,
      ListItem,
      onClick, propName,
      activeIds,
      disabledIds,
      // eslint-disable-next-line no-unused-vars,react/prop-types
      loadMoreRows,
      ...otherProps
    } = this.props;
    const item = DataUtil.asArray(list)[index];

    return (
      <CellMeasurer
        cache={this._cache}
        columnIndex={0}
        key={key}
        rowIndex={index}
        parent={parent}
      >
        {({ measure }) => {
          if (!item) {
            return null;
          }
          let active = this.checkInIdList(item, activeIds, propName);
          let disabled = this.checkInIdList(item, disabledIds, propName);

          return (
            <div style={{ ...style }} key={key}>
              <ListItem
                {...otherProps}
                index={index}
                item={item}
                disabled={disabled}
                active={active}
                onClick={onClick}
                onLoad={measure}
                list={list}
              />
            </div>
          );
        }}
      </CellMeasurer>
    );
  }

  isRowLoaded({ index }) {
    return index < DataUtil.asArray(this.props.list).length;
  }

  render() {
    const { list, loadMoreRows, size = 'small', rowHeight = 50, selectedNamedList, ...otherProps } = this.props;
    const listSize = selectedNamedList ? selectedNamedList.entries.length : (list && list._count || 0);
    const listItems = list && list.item;
    let height = 345;

    if (window.innerWidth < 1200) {
      height = 345;
    } else {
      if (size === 'medium') {
        height = 500;
      } else if (size === 'large') {
        height = 920;
      } else if (isFinite(size)) {
        height = parseInt(size);
      }
    }

    if (listItems && listItems.length === 0 && !(list && list._more)) {
      return (
        <FlagComponent item={list}>
          <div style={{ height: height }}
               className="error-message">{translation.trans('no-entries')}</div>
        </FlagComponent>
      );
    }

    return (

      <InfiniteLoader
        ref={loader => this.loader = loader}
        isRowLoaded={this.isRowLoaded}
        loadMoreRows={loadMoreRows}
        rowCount={listSize}
        minimumBatchSize={AppContext.DEFAULT_LIST_SIZE}
        threshold={15}>
        {({ onRowsRendered, registerChild }) => (
          <AutoSizer disableHeight>
            {({ width }) => (
              <List
                {...otherProps}
                height={height}
                ref={registerChild}
                onRowsRendered={onRowsRendered}
                rowCount={listSize}
                rowHeight={rowHeight || this._cache.rowHeight}
                rowRenderer={this.rowRenderer}
                width={width}
              />
            )}
          </AutoSizer>
        )}
      </InfiniteLoader>
    );
  }
}

ScrollableDataListRV.propTypes = {
  ListItem: PropTypes.func.isRequired,
  activeIds: PropTypes.object,
  disabledIds: PropTypes.object,
  list: PropTypes.object,
  className: PropTypes.string,
  propName: PropTypes.string,
  loadMoreRows: PropTypes.func.isRequired,
  onClick: PropTypes.func,
  rowHeight: PropTypes.oneOfType([ PropTypes.number, PropTypes.func ]),
  useResponsiveHeight: PropTypes.bool,
  selectedNamedList: PropTypes.object,
  size: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ])
};

export default DataListHoc(ScrollableDataListRV);



// WEBPACK FOOTER //
// ./js/components/ScrollableDataListRV.jsx